import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BulletinService {
  bulletinList: AngularFireList<any>;
  changeBulletin = new BehaviorSubject<string>('');

  constructor(private firebase: AngularFireDatabase) { }

  getBulletin() {
    this.bulletinList = this.firebase.list('bulletin');
    return this.bulletinList;
  }
}
